// extracted by mini-css-extract-plugin
export var wordContainer = "_ql-0";